import { useEffect, useState } from 'react';
import { throttle } from 'lodash';
import canUseDOM from '../../util/canUseDOM';

const getScrollPosition = () => {
  return { x: window.scrollX, y: window.scrollY };
};

const useScrollPosition = () => {
  const [scrollPos, setScrollPos] = useState({ x: 0, y: 0 });

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (!canUseDOM) { return null; }
    setScrollPos(getScrollPosition());

    const handleScroll = throttle(() => {
      setScrollPos(getScrollPosition());
    }, 500);

    // Bind lisenter
    window.addEventListener('scroll', handleScroll);
    // Unbind listener on Unmount
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return scrollPos;
};

export default useScrollPosition;
